import { Types } from 'mongoose';

import { ReconciliationType } from '@shared/constants';

import { IBaseEntity } from '../common';

export interface TableData {
  [key: string]: any;
  checked?: boolean;
}

export interface ColumnConfig {
  field: string;
  header: string;
  clickable?: boolean;
  isCurrency?: boolean;
}

export interface IReconciliationListItem {
  id: string;
  type: string;
  insurer: string;
  date_range: string;
  reconcile_date: string;
  insurerId: string;
}

export interface IBrokerTable {
  _id?: string;
  policyNumber: string;
  adviserNumber: string;
  amount: number;
  invoiceNumber: string;
}

export interface IInsurerTable {
  _id?: string;
  policyNumber: string;
  amount: number;
  invoiceNumber: string;
}

export interface IReconciliation extends IBaseEntity {
  type: ReconciliationType;
  insurer: Types.ObjectId | string;
  start: Date | string;
  end: Date | string;
  brokerData: IBrokerTable[];
  insurerData: IInsurerTable[];
  insurerName?: string;
  tenant?: string | Types.ObjectId;
}

export enum RECONCILIATION_TABLE_FIELDS {
  TYPE = 'type',
  INSURER = 'insurer',
  DATE_RANGE = 'date_range',
  RECONCILED_DATE = 'reconcile_date',
}
